import styled from 'styled-components';

export const RecentArticlesList = styled.ul`
  list-style: disc;
  margin: 24px 16px;
  display: grid;
  grid-template-columns: repeat(2, 45%);
  justify-content: space-between;

  li {
    font-size: clamp(14px, 2vw, 16px);
    padding-bottom: 20px;
    font-weight: 500;
    text-decoration: underline;
    text-underline-offset: 3px;
    color: #000000c4;
    cursor: pointer;

    @media (max-width: 720px) {
      cursor: default;
    }
    &.lowOpacity {
      opacity: 0.5;
    }
  }

  @media (max-width: 720px) {
    grid-template-columns: 100%;
    margin-left: 28px;
  }
`;

export const RecentArticleContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 45%);
  justify-content: space-between;
  padding: 0 16px;

  @media (max-width: 720px) {
    grid-template-columns: 100%;
  }
`;

export const RecentArticleCardStyle = styled.div`
  display: flex;
  column-gap: 14px;
  align-items: center;
  width: 100%;
  position: relative;
  overflow: hidden;
  padding: 15px 0;
  border-bottom: 1px solid hsl(0deg, 0%, 0%, 12%);

  @media (max-width: 720px) {
    border-bottom: none;
  }

  &:nth-last-child(1) {
    border-bottom: none;
  }

  &.lowOpacity {
    opacity: 0.5;
  }

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: rippleB 450ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes rippleB {
    to {
      transform: scale(2);
      opacity: 0;
    }
  }
`;

export const RecentArticleImage = styled.img`
  width: 108px;
  max-height: 70px;
  height: 100%;
  border-radius: 4px;
  filter: brightness(0.95);
  object-fit: cover;
`;

export const RecentDescriptionContainer = styled.div`
  margin-top: 0;
  @media (max-width: 720px) {
    order: -1;
  }
`;
